import { Col, Grid, notification, Row, Select, Space, Spin, Tag } from 'antd';
import * as Api from 'api';
import CameraRemoteBig from 'components/camera/cameraRemoteBig';
import { CameraPinType } from 'helpers/types';
import React, { useEffect, useState } from 'react';
import useAuth from 'redux/auth/auth.hook';
import CameraRemoteMini from 'components/camera/cameraRemoteMini';
import AttComponent from 'components/camera/cameraSimbols/AttComponent';
import CameraRemoteDC2 from 'components/camera/cameraRemoteDC2';
import CameraRemoteDC2B from 'components/camera/cameraRemoteDC2B';
import CameraRemoteMC2 from 'components/camera/cameraRemoteMC2';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;

const { Option } = Select;
const CameraRemotePage = () => {
  const { md } = useBreakpoint();
  const [loading, setLoading] = useState(false);
  const [cameras, setCameras] = useState<CameraPinType[]>([]);
  const [selected, setSelected] = useState(0);

  const { auth: { profile } } = useAuth();
  const [camera, setCamera] = useState<any>(null);
  const [device, setDevice] = useState<any>(null);
  const [component, setComponent] = useState<any>(null);
  const [cameraType, setCameraType] = useState<any>(null);

  useEffect(() => {
    if (profile) {
      httpGetCameras();
    }
  }, [profile]);

  const changeCamera = (value) => {
    console.log(`selected ${value}`);
    setSelected(value);
    setCamera(cameras[value]);
    httpGetInfo(cameras[value].IMEI);
  };

  const httpGetCameras = () => {
    setLoading(true);
    Api.CAMERA_GET_LIVE_ALL().then(((res: any) => {
      setLoading(false);
      const result = JSON.parse(res.text);
      setCameras(result.data);
      if (result.data.length > 0) {
        setCamera(result.data[0]);
        httpGetInfo(result.data[0].IMEI);
      } else {
        notification.open({
          message: 'You don\'t have any activated smart cams now',
        });
      }
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const httpGetInfo = (IMEI) => {
    setLoading(true);
    const params = {
      IMEI,
    };
    Api.CAMERA_GET_LIVE_INFO(params).then(((res: any) => {
      setLoading(false);
      const result = JSON.parse(res.text);
      if (result.data == null) {
        notification.open({
          message: 'Invalue IMEI',
        });
      } else {
        if (result.data.version == 'B' && result.data.pir_sensitivity == 0) {
          result.data.pir_sensitivity = 5;
        }
        setDevice(result.data);
      }
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  useEffect(() => {
    if (device != null && camera != null) {
      if (device.version == 'A') {
        setCameraType('Standard');
        setComponent(<CameraRemoteBig device={device} camera={camera} />);
      } else if (device.version == 'B') {
        setCameraType('Mini');
        setComponent(<CameraRemoteMini device={device} camera={camera} />);
      } else if (device.version == 'C') {
        setCameraType('DataCam');
        setComponent(<CameraRemoteMini device={device} camera={camera} />);
      } else if (device.version == 'MC2') {
        setCameraType(device.version);
        setComponent(<CameraRemoteMC2 device={device} camera={camera} />);
      } else if (device.version == 'DC2') {
        setCameraType(device.version);
        setComponent(<CameraRemoteDC2 device={device} camera={camera} />);
      } else if (device.version == 'DC2B') {
        setCameraType(device.version);
        setComponent(<CameraRemoteDC2B device={device} camera={camera} />);
      }
    }
  }, [device]);

  return (
    <>
      <Row>
        <Col xs={24}>
          <div className={classes.content} style={{ padding: md ? 24 : 16 }}>
            <Spin spinning={loading} size="large">
              <div className={classes.divCamera}>
                <Space>
                  <div className={classes.formInputLabel}>Camera:&nbsp;</div>
                  <Select
                    size="large"
                    className={classes.select}
                    onChange={changeCamera}
                    value={selected}
                  >
                    {cameras.map((val: any, i) => (
                      <Option key={val.id} value={i}>{val.name}</Option>
                    ))}
                  </Select>
                  <Tag>
                    {cameraType}
                  </Tag>
                  {device != null && (<AttComponent detail={device} />)}
                </Space>
              </div>
              {component}
            </Spin>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default CameraRemotePage;
